import NpsScoreSection from './NpsScoreSection';

export default NpsScoreSection;
